import { render, staticRenderFns } from "./examsList.vue?vue&type=template&id=0e8a7dc6"
import script from "./examsList.vue?vue&type=script&lang=js"
export * from "./examsList.vue?vue&type=script&lang=js"
import style0 from "./examsList.vue?vue&type=style&index=0&id=0e8a7dc6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports